import { handleV4Error } from 'utils';
import * as constants from '../constants';

/**
 * Document it
 * @param {object} state - state
 * @param {object} action - action
 * @returns {object} - mutated state
 */
export default function api(state, action) {
    const apiHash = {};
    switch (action.type) {
        case constants.API_FETCH_SUCCESS:
            if (action.response.length) {
                action.response.forEach(resp => {
                    apiHash[resp.endpoint] = resp.json;
                });
            } else {
                apiHash[action.response.endpoint] = action.response.json;
            }
            return { ...state, ...apiHash };
        case constants.API_FETCH_FAILED:
            return {
                ...state,
                [action.response.endpoint]: action.response.json,
                [constants.PENDING]: false,
            };
        case constants.API_CLEAR_SUCCESS:
            return { ...state, [action.endpoint]: null };
        case constants.HIDE_WELCOME_BANNER:
            return {
                ...state,
                [action.endpointName]: {
                    ...state[action.endpointName],
                    isEnabled: false,
                },
            };
        case constants.HTTP_GET_CALL_COMPLETED:
            return { ...state, [constants.PENDING]: false };
        case constants.PRISM_API_PRE_LOGIN_SUCCESS:
            // Get customLogin property from /v1/utils/pre_login_details
            return { ...state, [constants.CUSTOM_LOGIN]: action.response.json };
        case constants.PRISM_API_FETCH_SUCCESS:
            return { ...state, [constants.PRISM_VERSION]: action.response.json };
        case constants.PRISM_API_FETCH_FAILED:
            return { ...state, [constants.PRISM_VERSION]: action.error.json };
        case constants.LOGIN_REQUEST_SUCCESS:
            return {
                ...state,
                success: true,
                error: null,
                errorMessage: null,
            };
        case constants.v4_API_FETCH_REQUEST: {
            const options = {};
            if (action?.payload?.name) {
                options[action.payload.name] = {
                    [constants.PENDING]: true,
                };
            }
            return {
                ...state,
                ...options,
                [constants.PENDING]: true,
            };
        }
        case constants.V4_API_FETCH_SUCCESS: {
            const options = {};
            if (action?.payload?.name) {
                options[action.payload.name] = {
                    [constants.PENDING]: false,
                };
            }
            return {
                ...state,
                ...options,
                success: false,
                error: null,
                errorMessage: null,
                [action.name]: action.data,
                [constants.PENDING]: false,
            };
        }
        case constants.V4_API_GENERAL_FAILED:
        case constants.V4_API_FETCH_FAILED: {
            let errorMessage = null;
            handleV4Error(action.error, message => {
                errorMessage = message;
            });
            const options = {};
            if (action?.payload?.name) {
                options[action.payload.name] = {
                    [constants.PENDING]: false,
                };
            }
            return {
                ...state,
                ...options,
                errorMessage,
                shouldPresentAsGeneralError: constants.V4_API_GENERAL_FAILED === action.type,
                [action.name]: action.error,
                [constants.PENDING]: false,
            };
        }
        case constants.V4_API_IGNORE_ERROR: {
            return {
                ...state,
                [action.name]: action.error,
                [constants.PENDING]: false,
            };
        }

        default:
            return { ...state, [constants.PENDING]: true } || null;
    }
}
